import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { format, parse, isValid } from "date-fns";
import { enGB, sq, srLatn } from "date-fns/locale";
import { useT } from "@/i18n";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const LOC = { en: { l: enGB, f: "dd/MM/yyyy" }, sq: { l: sq, f: "dd.MM.yyyy" }, sr: { l: srLatn, f: "dd.MM.yyyy." } };
const iso = (d) => format(d, "yyyy-MM-dd");
const fromIso = (s) => { if (!s) return null; const d = parse(s.slice(0, 10), "yyyy-MM-dd", new Date()); return isValid(d) ? d : null; };

export function DateInput({ value, onChange, className = "", placeholder, ...rest }) {
  const { lang } = useT();
  const { l, f } = LOC[lang] || LOC.en;
  const d = fromIso(value);
  const [text, setText] = useState(d ? format(d, f) : "");
  const [open, setOpen] = useState(false);
  useEffect(() => { const x = fromIso(value); setText(x ? format(x, f) : ""); }, [value, f]);
  const commit = () => {
    const t = text.trim();
    if (!t) return onChange("");
    let p = parse(t, f, new Date());
    if (!isValid(p)) p = parse(t, f.replace(/\.$/, ""), new Date());
    if (!isValid(p)) p = fromIso(t);
    if (isValid(p) && p) onChange(iso(p)); else setText(d ? format(d, f) : "");
  };
  return <div className={`flex items-center h-9 w-40 rounded-md border border-input bg-background text-sm shadow-sm focus-within:ring-1 focus-within:ring-ring ${className}`}>
    <input value={text} placeholder={placeholder || f.toUpperCase()} onChange={(e) => setText(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === "Enter" && commit()} className="flex-1 min-w-0 bg-transparent px-3 py-1 outline-none" {...rest} />
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild><button type="button" className="px-2 text-muted-foreground hover:text-foreground" aria-label="calendar" data-testid={rest["data-testid"] ? `${rest["data-testid"]}-cal` : undefined}><CalendarDays className="h-4 w-4" /></button></PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-card" align="end"><Calendar mode="single" locale={l} selected={d || undefined} defaultMonth={d || undefined} onSelect={(x) => { if (x) onChange(iso(x)); setOpen(false); }} initialFocus /></PopoverContent>
    </Popover>
  </div>;
}
